import './sidebar.css';
import config from '../config';

function Sidebar({ activeView, onSwitchView }) {
  const download_wholeData = () => {
  fetch('https://alembicdigilabs.in/digilabs/mis/export-excel', {
    method: 'GET'
  })
    .then(response => {
      if (!response.ok) {
        throw new Error("Failed to download file");
      }
      return response.blob();
    })
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'MIS-Data.xlsx'; // filename
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    })
    .catch(error => {
      console.error('Error:', error);
    });
};


  return (
    <div className='sidebar'>
      <div className='logo-container'>
        <img src={config.logo} alt='logo' style={{ "placeSelf": 'center' }} />
      </div>
      <div className='selection-container'>
        {/* <div>
          <span>MAIN</span>
        </div> */}
        <div onClick={() => onSwitchView("dashboard")} >
          <img src={activeView === 'dashboard' ? config.activeDashboard : config.inactiveDashboard} alt='' />
          <span>Overview</span>
        </div>
        <div onClick={() => onSwitchView("insight")}>
          <img src={activeView === 'insight' ? config.activePiechart : config.inactivePiechart} alt='' />
          <span>Breakdown</span>
        </div>
        <div onClick={download_wholeData}>
          <img src={config.download_wholeData} alt='Download Whole Data' />
        </div>
      </div>
      <div className='logout-container'>
        <div>
          <span>LOGOUT</span>
        </div>
        <div>
          <img src={config.logout} alt='logout' />
        </div>
      </div>
    </div>
  )
}

export default Sidebar;
